export default "27e42fbc73966b7c.svg"